import { ReactNode } from 'react';

import { AffiliateBaseThemeType, ChatBaseThemeType, RecursiveThemeValue } from '@repo/styles';
import { ThemeProvider } from 'styled-components';

const UIThemeProvider = <T extends RecursiveThemeValue<AffiliateBaseThemeType>>({
  theme,
  children,
}: {
  theme: T;
  children: ReactNode;
}) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default UIThemeProvider;
